"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const b_1 = __importDefault(require("b_"));
const types_1 = require("src/types");
const modal_1 = require("src/context/modal");
const branding_1 = require("src/context/branding");
const focus_1 = require("src/hooks/focus");
const input_styles_1 = __importDefault(require("./input.styles"));
const b = b_1.default.with('input');
const TEXT_AREA_MAX_HEIGHT = 200;
// eslint-disable-next-line react/display-name, complexity
const Input = (0, react_1.forwardRef)((props, ref) => {
    const { textArea, type = 'text', mix = '', size } = props, inputProps = __rest(props, ["textArea", "type", "mix", "size"]);
    const context = (0, modal_1.useModalContext)();
    const isMorda = (context === null || context === void 0 ? void 0 : context.surveyPreset) === types_1.SurveyPreset.YandexMorda;
    const branding = (0, branding_1.useBrandingContext)() || {};
    const { isMouseFocused, handleMouseDown, handleKeyDown, handleBlur } = (0, focus_1.useMouseFocus)(props);
    const extendedInputProps = Object.assign(Object.assign({}, inputProps), { onMouseDown: handleMouseDown, onKeyDown: handleKeyDown, onBlur: handleBlur });
    const { input: { autogrow = isMorda, border: { type: borderType = isMorda ? 'bottom' : 'around' } = {} } = {} } = branding;
    const className = b('control', { mousefocus: isMouseFocused });
    const stylesApplied = (0, input_styles_1.default)({ size });
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ "data-value": props['data-value'], css: stylesApplied, className: `${b({ size, autogrow, textarea: textArea })} ${mix}`.trim(), ref: ref }, { children: [textArea && ((0, jsx_runtime_1.jsx)(TextArea, Object.assign({ className: className }, extendedInputProps, { autogrow: autogrow }))), !textArea && (0, jsx_runtime_1.jsx)("input", Object.assign({ className: className, type: type }, extendedInputProps)), borderType === 'bottom' && (0, jsx_runtime_1.jsx)("div", { className: b('bottom-border') })] })));
});
exports.default = Input;
function TextArea(_a) {
    var _b;
    var { autogrow, placeholder, value, onBlur, onFocus, onChange, className } = _a, rest = __rest(_a, ["autogrow", "placeholder", "value", "onBlur", "onFocus", "onChange", "className"]);
    const textAreaRef = (0, react_1.useRef)(null);
    const offsetHeight = ((_b = textAreaRef === null || textAreaRef === void 0 ? void 0 : textAreaRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
    const overflow = autogrow && offsetHeight < TEXT_AREA_MAX_HEIGHT ? 'hidden' : 'auto';
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ "data-replicated-value": value, className: b('textarea-wrapper', { autogrow }) }, { children: (0, jsx_runtime_1.jsx)("textarea", Object.assign({ rows: 1, className: className, style: { overflow }, placeholder: placeholder, value: value, onBlur: onBlur, onFocus: onFocus, onChange: onChange, ref: textAreaRef }, rest)) })));
}
